var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWrongAbroad = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 81,
    viewBox: "0 0 82 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9979 8.1001C23.0969 8.1001 8.5979 22.5991 8.5979 40.5001C8.5979 58.4011 23.0969 72.9001 40.9979 72.9001C58.8989 72.9001 73.3979 58.4011 73.3979 40.5001C73.3979 22.5991 58.8989 8.1001 40.9979 8.1001Z",
    fill: "#AD0B01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4978 27L54.4978 54M27.4978 54L54.4978 27",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWrongAbroad);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Wrong_abroad.16acf13967d90337483189a3d7fd71f1.svg";